import './Services.css';
import content from '../data/content.json';

const Services: React.FC = () => {
  return (
    <section className="services" id="servicos">
      <div className="container">
        <h2>{content.services.title}</h2>
        <p className="section-subtitle">{content.services.subtitle}</p>
        <p className="services-description">{content.services.description}</p>

        <div className="services-grid">
          {content.services.items.map((service, index) => (
            <div key={index} className="service-card">
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
